<template>
  <v-container fluid
               id="cities"
               class="wsp-padding"
               grid-list-xl>
    <h2 class="citySelector primary--text"
        v-html="$t('choose.a.city.text')"></h2>
    <v-layout row
              wrap
              justify-center>

      <template v-for="(city, index) in cities">
        <v-flex xs12
                sm4
                :key="index">
          <a @click="goToCity(city)"
             v-if="city.action">
            <v-card raised
                    hover>

              <v-responsive name="index">
                <img :srcset="getCityImageSrcset(city.image)"
                     :src="`/static/img/${city.image}.jpg`" />
              </v-responsive>
              <v-card-actions class="pa-0">
                <v-btn color="accent"
                       block>{{ city.name }}</v-btn>
              </v-card-actions>
            </v-card>
          </a>

          <v-card v-else
                  flat
                  @click.native="toggleCardText(city)"
                  class="disabled">
            <v-responsive name="index">
              <img :srcset="getCityImageSrcset(city.image)"
                   :src="`/static/img/${city.image}.jpg`" />
            </v-responsive>
            <v-card-actions class="pa-0">
              <v-btn block
                     disabled>
                {{ city.text}}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </template>
    </v-layout>
  </v-container>
</template>

<script>
import store from '@/store';
import keys from '@/store/keys';
import oLocalStorage from '@/services/objectLocalStorage';

export default {
  name: 'CityBoxes',

  data() {
    return {
      cities: store.state.cities
    };
  },
  mounted() {},
  methods: {
    toggleCardText(value) {
      if (value.text === this.$i18n.t('global.comingSoon')) {
        value.text = value.name;
      } else {
        value.text = this.$i18n.t('global.comingSoon');
      }
    },
    goToCity(city) {
      oLocalStorage.set(keys.citySelected, city);
      window.location = city.action;
    },
    getCityImageSrcset(image) {
      return `/static/img/${image}.jpg,
              /static/img/${image}_600_450.jpg 2x`;
    }
  }
};
</script>

<style lang="scss" scoped>
.wsp-padding {
  padding: 0 10%;
}
#cities {
  margin-top: 4em;
}
#cities img {
  width: 100%;
  height: 100%;
}
#cities .disabled img {
  -webkit-filter: grayscale(100%); /* Ch 23+, Saf 6.0+, BB 10.0+ */
  filter: grayscale(100%);
}

#cities button {
  text-transform: capitalize;
  font-size: 18px;
}
.citySelector {
  margin-bottom: 1vh;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/CityBoxes.vue